import client from 'client';

type CreateChannelResponse = {
    id: string;
};

export const createChannelApi = async ({ members }: { members: number[] }, eventId: string) => {
    const data = {
        contextType: 'private',
        contextId: '',
        name: '',
        participants: members,
    };
    const res = await client().post<CreateChannelResponse>(
        `/api/v2/chat/events/${eventId}/chat/channels/`,
        data
    );
    return res.data;
};
